import { useState } from "react";
import { useLocation } from "wouter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import NewClaimModal from "@/components/claims/modals/new-claim-modal";
import { Plus, BarChart } from "lucide-react";

export default function QuickActions() {
  const [showNewClaimModal, setShowNewClaimModal] = useState(false);
  const [, navigate] = useLocation();

  const actions = [
    {
      title: "New Claim Intake",
      icon: Plus,
      variant: "default" as const,
      onClick: () => setShowNewClaimModal(true),
      testId: "action-new-claim-intake",
    },
    {
      title: "Generate Report",
      icon: BarChart,
      variant: "outline" as const,
      onClick: () => navigate("/reports"),
      testId: "action-generate-report",
    },
  ];

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold text-foreground">
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {actions.map((action) => {
            const Icon = action.icon;
            
            return (
              <Button
                key={action.title}
                variant={action.variant}
                onClick={action.onClick}
                className="w-full justify-center py-3"
                data-testid={action.testId}
              >
                <Icon className="h-4 w-4 mr-2" />
                {action.title}
              </Button>
            );
          })}
        </CardContent>
      </Card>

      <NewClaimModal 
        open={showNewClaimModal} 
        onOpenChange={setShowNewClaimModal}
      />
    </>
  );
}
